import { DriversInvalidRecord } from './drivers-invalid-record';

export class DriversImportResponse {
  constructor(
    public imported = 0,
    public importInserted = 0,
    public importUpdated = 0,
    public invalid: DriversInvalidRecord[] = [],
    public unrecoverable = 0,
    public importComplete = false
  ) {}
}
